import AWS from 'aws-sdk';
import Store from '../store/store';
import AWS_PROPERTIES from '../aws-exports';
import {ACCT_TYPES} from '../shared/enums/UserType';

AWS.config.region = AWS_PROPERTIES.Storage.region; // Region

const Handler = {

    async initCredentials (session){
        const poolUrl = 'cognito-idp.'+ AWS_PROPERTIES.Auth.region+'.amazonaws.com/'+AWS_PROPERTIES.Auth.userPoolId;
        const login = {};
        login[poolUrl] = session.getIdToken().getJwtToken();

        const credentialParams = {
            IdentityPoolId: AWS_PROPERTIES.Auth.identityPoolId,
            Logins: login
        };


        if( AWS.config.credentials === null || AWS.config.credentials.needsRefresh()) {
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(credentialParams);
        }

        const credentias = new Promise ((resolve, reject) => {
            AWS.config.credentials.refresh((err) => {
                if (err) {
                    reject(err);
                } else {
                    resolve('SUCCESSFULLY UPDATED');
                }
            });
        });

        let response = await credentias;
        return response;
    },
    async execute(requestType, params) {
        let user = Store.getters.getUser;

        try {
            await this.initCredentials(user.signInUserSession);
        }
        catch (e) {
            throw e;
        }

        if(user.attributes['custom:acctType'] === ACCT_TYPES.ORGANIZATION){
            if(params.Metadata.belong){
                params.Key = user.attributes['custom:orgID']+'/'+params.Metadata.belong+'/'+params.Key;
            }
            else {
                params.Key = user.attributes['custom:orgID']+'/'+params.Key;
            }
        }
        else if(user.attributes['custom:acctType'] === ACCT_TYPES.EMPLOYEE){
            params.Key = user.attributes['custom:orgID']+'/'+user.attributes.sub+'/'+params.Key;
        }

        if(requestType === 'upload'){
            if(params.Metadata === null){
                let metadata = {
                    'uploader': user.attributes.sub
                };
                params.Metadata = metadata;
                //set ContentDisposition for the file to be prompt for download
                params.ContentDisposition = "attachment";
            }
            else{
                params.Metadata['uploader'] = user.attributes.sub;
            }

        }
        else{
            delete params.Metadata;
        }

        const s3 = new AWS.S3({apiVersion: '2006-03-01'});
        const request = new Promise((resolve, reject) => {
            s3[requestType](params, function untilDone(err, data) {
                if (err) {
                    reject(err)
                }
                else {
                    // all results scanned. done!
                    resolve(data)
                }
            });
        });

        let result;
        try{
            result = await request;
            return result;
        }
        catch(e){
            throw e;
        }
    },
    async createFile (path, file, metadata){
        if(!!!file){
            throw 'Invalid file';
        }

        if(path){
            path = path+'/';
        }
        else {
            path = '';
        }

        path = path + metadata.name;

        let uploadParams = {Bucket: AWS_PROPERTIES.Storage.bucket, Key: path,
            ContentType: file.type, Body: file, Metadata: metadata};
        try{
            await this.execute('upload', uploadParams);
        }
        catch (e) {
            console.error('User is not allow to create a file. Error: ' + e);
            throw 'User is not allow to create a file. Error: ' + e;
        }
    },
    async readFile (folder, metadata){
        let path = '';
        if(!!!folder){
            path = metadata.fileName;
        }else{
            path = folder + '/'+metadata.fileName;
        }

        let  readParams = {
            Bucket: AWS_PROPERTIES.Storage.bucket,
            Key: path,
            Metadata: metadata
        };

        try{
            let file = await this.execute('getObject', readParams);
            const a = document.createElement('a');
            const type = path.split(".").pop();
            a.href = URL.createObjectURL( new Blob([file.Body], { type:`text/${type === "txt" ? "plain" : type}` }) );
            a.download = path.split("/").pop();
            a.click();
        }
        catch (e) {
            console.error('File not found or User is not allow to access it. Error: ', e);
            throw 'File not found or User is not allow to access it. Error:' + e;
        }
    }
};

export default Handler;